<template>
  <div class="about">
    <toolbar-user></toolbar-user>
    <v-container dir="rtl">
      <v-card class="changeTitleStyle mb-6">
              <v-card-title class="changeTitleStyle">
                <h3>فن الريزن ما هو؟</h3>
              </v-card-title>
              <v-card-text class="importantSite ">
                <h3>

                الريزن أو إيبوكسي الراتنجات (بالإنجليزية: Resin Epoxy)‏ مادة كيمائية تعتبر أحد أنواع اللدائن الصلبة بالحرارة، ذات مركبين: أساس (resin) ومصلب (hardener) وهي شديدة الالتصاق ومقاوم للاحتكاك والمواد الكيماوية سواء كانت أحماض أو قواعد أو مذيبات، حيث تتشكل طبقة عازلة عند جفافها. تستخدم كطلاء أو مونة أو لاصق، أكثر أنواع الإيبوكسي الراتنج إنتاجا هي الناتجة عن التفاعل بين مادتي (epichlorohydrin) و(bisphenol) ألف الكيميائيتين.
أول محاولة لإنتاجه من هذه المادة كانت في عام 1927 بالولايات المتحدة عبر شركة سيبا السويسرية لإنتاج الكيماويات.
وينتمي راتنج الإيبوكسي إلى مجموعة الراتنجات المتصلبة بالحرارة؛ إذ تتميز هذه الراتنجات بعدم إمكانية إعادة تشكيلها بالحرارة بعد تحولها إلى مادة صلبة نتيجة لتكون سلاسل بوليميرية طويلة متشابكة مع بعضها وهو ما يسمى بالربط التشابكي.
ويحتوي راتنج الإيبوكسي على مجموعتين أو أكثر من مجاميع الإيبوكسايد التي تتألف من ذرة أُوكسجين مرتبطة مع ذرتي كاربون ترتبط مجموعة الإيبوكسي كيميائيا مع الجزيئات الأُخرى لتشكيل شبكة ثلاثية الأبعاد ذات ربط تشابكي بعملية المعالجة.
ويتميز راتنج الإيبوكسي بالصلادة والمقاومة الكيميائية العاليتين نسبيا، بالإضافة إلى ذلك يمتلك هذا الراتنج قابلية إلتصاق نوعي عالي بسبب التركيب الكيميائي لهذا الراتنج والمتمثل في مجموعة الإيثرات والهيدروكسيل والمجاميع القطبية التي تعطي متانة وإلتصاق عالية وتكسب المادة صلادة وقوة؛ لذلك يستعمل في التطبيقات التي تتطلب إداءا وظيفيا عاليا.
وتتفاعل هذه الراتنجات مع المصلدات أثناء المعالجة ويكون التفاعل غير مصحوب بإنبعاث الماء أو تحرر أي منتجات ثانوية مما يجعل التقلص الحجمي قليل جداً (أقل من 2%)، وبالتالي يكتسب الراتنج قوة وخواص ميكانيكية عالية، بالإضافة إلى ذلك تمتلك راتنجات الإيبوكسي المعالجة متانة عالية نتيجة للبعد بين نقاط الربط التشابكي ووجود السلاسل الإليفانية المتكاملة.
                </h3>
                <br />
              </v-card-text>
      
               <v-expansion-panels
               class=" pa-10"
      v-model="panel"
    
      multiple
    >
      <v-expansion-panel v-for="item,i in risenDefination" :key="i" class='animate__animated animate__backInRight animate__slow ' >
        <v-expansion-panel-title class="fade-in titlePanel">{{item.title}}</v-expansion-panel-title>
        <v-expansion-panel-text class="textPanel">
         {{item.subtext}}
        </v-expansion-panel-text>
      </v-expansion-panel>
                
              </v-expansion-panels>
</v-card
            >
    </v-container>
  </div>
</template>
<script>
import ToolbarUser from '../components/ToolbarUsers.vue'

export default {
  components:{
ToolbarUser
  },
  data:()=>({
    panel:[0,1,2],
       risenDefination:[
      {title:'أين يباع الريزن؟',subtext:'في الفترة القليلة الماضية وبعد انتشارأعمال من الريزن أصبح هناك كثيرون يبيعون مادة الريزن في المحلات الكبيرة لبيع الدهانات والكيماويات أو مكاتب الديكورات التي تصنع ديكورات ثلاثية الأبعاد وأرضيات وحوائط إيبوكسي يمكنك الشراء منهم'},
    {title:'الأدوات المستخدمة في منتجات الريزن', subtext:' قفازات نايتريل- أقنعة خفيفة- أوعية لخلط الريزن فيها- ميزان للغرامات- أدوات لخلط الريزن، مثل الملاعق البلاستيكية أو العصي الخشبية العريضة.- قوالب.- أشياء لتغطية وحماية شغل الريزن بها، مثل أغطية بلاستيكة أو كرتونية.- مصدر حرارة/ لهب.- صبغات أو ألوان/ملونات للريزن.- حصيرة سيليكون. لاصق (لزيّق) شفاف.'}]
 })
}
</script>
<style scoped>
.changeTitleStyle {
  background: rgba(154, 51, 149, 0.156) !important;
  direction: rtl !important;
}
.titlePanel{
  background-color: rgba(117, 21, 112, 0.41) !important;;
}
.titleText{
  background-color: rgba(154, 51, 149, 0.156) !important;;
}

</style>
